import axios from '@/axios/axios2'

// 获取旺铺分润明细
export const getWPIncome = params => axios.post('/account/getWPIncome', params)

// 获取普通分润明细
export const getIncome = params => axios.post('/account/get_income', params)

// ------------------------------------------改↓------------------------------------------------------------
// 获取分润详情
export const getFrDetails = params => axios.post('/frInfo/getFrDetails', params)

// 获取分润交易详情
export const getFrDataList = params =>
  axios.post('/frInfo/getFrDataList', params)

// 获取旺铺详情
export const getWPFrDetails = params =>
  axios.post('/frInfo/getWPFrDetails', params)

// 获取旺铺分润交易详情
export const getWPFrDataList = params =>
  axios.post('/frInfo/getWPFrDataList', params)
